export { default } from "~/components/minicart/index";
import type { Props } from "~/components/minicart/index";
import { type FnContext as FnContext } from "~/types/deco";
export function loader(props: Props, _request: Request, ctx: FnContext) {
    return {
        ...props,
        isMobile: ctx.device !== 'desktop',
    };
}

export const sync = true;
